import { c as _c } from "react/compiler-runtime";
import { Stack } from '@mui/material';
import { BackupJobType, RestoreJob, type BackupJob, type ScanJob } from '@repo/api-gw-sdk';
import { useEnvironment } from '@/contexts/useEnvironment';
import TemporalIcon from '../../../public/statics/images/apps/temporal.png';
import { CopyToClipboardWrapper } from '../buttons/copyToClipboardButton';
import { CircleImage } from '../shared/circleImage';
import { TextLink } from '../shared/textLink';
export const TemporalLinkField = t0 => {
  const $ = _c(19);
  const {
    entity
  } = t0;
  const {
    isDev
  } = useEnvironment();
  let t1;
  if ($[0] !== isDev) {
    t1 = () => {
      if (isDev) {
        return "http://localhost:37670";
      }
      if (location.host.endsWith("testing-console.eon.io")) {
        return "https://temporal.testing-infra.eon.io";
      }
      if (location.host.endsWith("console.app.eon.io")) {
        return "https://temporal.prod-infra.app.eon.io";
      }
      return "https://temporal.prod-infra.eon.io";
    };
    $[0] = isDev;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getTemporalBaseUrl = t1;
  let t2;
  if ($[2] !== entity) {
    t2 = () => {
      const fromJob = entity.jobExecutionDetails.workflowNamespace?.trim();
      if (fromJob) {
        return fromJob;
      }
      if (entity instanceof RestoreJob) {
        return "restore";
      }
      return "inventory";
    };
    $[2] = entity;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const getTemporalNamespace = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [BackupJobType.AwsDynamoDbBackupFull, BackupJobType.AtlasMongodbClusterBackupFull, BackupJobType.AwsKeyspacesBackupFull];
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const fullScanJobTypes = t3;
  let t4;
  if ($[5] !== entity) {
    t4 = () => {
      const jobId = entity.jobExecutionDetails.jobId;
      if ("backupType" in entity && entity.backupType && fullScanJobTypes.includes(entity.backupType)) {
        return `${jobId}${encodeURIComponent("/FullScan")}`;
      }
      return jobId;
    };
    $[5] = entity;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const getWorkflowId = t4;
  const t5 = entity.jobExecutionDetails.jobId;
  let t6;
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      alignItems: "center",
      gap: "8px"
    };
    t7 = <CircleImage src={TemporalIcon} alt="temporal" />;
    $[7] = t6;
    $[8] = t7;
  } else {
    t6 = $[7];
    t7 = $[8];
  }
  const t8 = getTemporalBaseUrl();
  let t9;
  if ($[9] !== getTemporalNamespace) {
    t9 = getTemporalNamespace();
    $[9] = getTemporalNamespace;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== getWorkflowId) {
    t10 = getWorkflowId();
    $[11] = getWorkflowId;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  const t11 = `${t8}/namespaces/${t9}/workflows/${t10}`;
  let t12;
  if ($[13] !== entity.jobExecutionDetails.jobId || $[14] !== t11) {
    t12 = <Stack direction="row" sx={t6}>{t7}<TextLink target="_blank" href={t11}>{entity.jobExecutionDetails.jobId}</TextLink></Stack>;
    $[13] = entity.jobExecutionDetails.jobId;
    $[14] = t11;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== entity.jobExecutionDetails.jobId || $[17] !== t12) {
    t13 = <CopyToClipboardWrapper textToCopy={t5}>{t12}</CopyToClipboardWrapper>;
    $[16] = entity.jobExecutionDetails.jobId;
    $[17] = t12;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  return t13;
};